export const TestIds = {
  svgIllustration: 'emptyState-svg-illustration',
  richTextLink: 'rich-text-link',
};
